import React, { Component } from 'react';
import Introduction from 'nbugs-product-introduction';
import { connect } from 'dva';
import moment from 'moment';
// eslint-disable-next-line import/no-extraneous-dependencies
import router from 'umi/router';
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Badge,
  Divider,
  Tooltip,
  Popconfirm,
  message,
  Select,
  Icon,
  Modal,
} from 'antd';
import Container from '../../../../../components/Container';
import ListPage from '../../../../../components/ListPage';
import CreateModal from './CreateModal';
import { getAppCode } from '../../utils/utils';
import { getLabelStrData } from '../../utils/convertData';
import { getPathHeader } from '../../../../../utils/utils';
import styles from './index.less';

const naozhongIcon = 'https://s.xiaoyuanhao.com/file/0667e1a2-9dc4-4e0e-91be-4847d7b23ddd.png'

const { ListTable } = ListPage;
const { Option } = Select;
const { confirm } = Modal;

const formAppData = {
  17: '微官网',
  18: '活动打卡'
}

const statusIcon = {
  1: '#FAAD14',
  3: '#F5222D',
  4: '#1785EC',
  5: '#52C41A',
  6: '#FAAD14',
  7: '#52C41A',
  8: '#C3C3C3',
  10: '#C3C3C3',
};

const statusText = {
  1: '拟稿中',
  3: '被打回',
  4: '审批中',
  5: '审批成功',
  6: '待发布',
  7: '已发布',
  8: '已撤下',
  10: '已撤回',
};
@connect(({ user }) => ({
  currentUser: user.currentUser,
}))
class ArticleSubmissions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      dataSource: [],
      loading: false,
      totalElements: 0,
      isShow: false,
      params: {
        title: '',
        appCode: getAppCode(),
        page: 1,
        pageSize: 10,
        status: 0,
        newsTypes: '0,1',
      },
      nowArticleType: null, // 当前选择的文章类型
      showModal: false,
      selectedRowKeys: []
    };
  }

  componentDidMount() {
    const { params } = this.state;
    this.fetchPermissions();
    this.fetchNewsLists(params);
    this.fetchIsShow();
  }

  search = e => {
    e.preventDefault();
    const { form } = this.props;

    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { params } = this.state;
        const tempParams = {
          ...params,
          title: values.title ? encodeURIComponent(values.title) : '',
          status: values.status ? encodeURIComponent(values.status) : '',
          page: 1,
        };
        this.setState({
          params: tempParams,
        });
        this.fetchNewsLists(tempParams);
      }
    });
  };

  reSet = () => {
    const { form } = this.props;
    form.resetFields();
    const { params } = this.state;
    const tempParams = { ...params, title: '', page: 1, status: 0 };
    this.setState({
      params: tempParams,
    });
    this.fetchNewsLists(tempParams);
  };

  fetchPermissions = () => {
    const { dispatch } = this.props;
    dispatch({
      type: 'articleSubmissions/fetchPermissions',
      params: {
        appCode: getAppCode(),
      },
    }).then(res => {
      this.setColumns(res);
    });
  };

  fetchNewsLists = params => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'articleSubmissions/fetchNewsLists',
      params,
    })
      .then(res => {
        this.setState({
          loading: false,
          dataSource: getLabelStrData(res),
          totalElements: res.totalElements,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  confirm = record => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'articleSubmissions/fetchDeleteById',
      params: { id: record.id, appCode: getAppCode() },
    })
      .then(() => {
        this.setState({ loading: false });
        message.success('删除成功');
        const { params } = this.state;
        this.fetchNewsLists(params);
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchSubmit = id => {
    const { dispatch } = this.props;
    const { params } = this.state;
    this.setState({ loading: true });
    dispatch({
      type: 'articleSubmissions/fetchSubmit',
      params: { ids: id, appCode: getAppCode() },
    })
      .then(() => {
        this.setState({ loading: false, selectedRowKeys: [] });
        message.success('提交成功');

        this.fetchNewsLists(params);
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchIsShow = () => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'articleSubmissions/fetchIsShow',
      params: {
        appCode: getAppCode(),
      },
    })
      .then(res => {
        this.setState({ loading: false, isShow: res });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  toMicroToPublic = () => {
    const { isShow, params } = this.state;
    if (!isShow) {
      message.error('暂未绑定公众号，请先网站设置-公众号设置处绑定');
    } else {
      const { dispatch } = this.props;
      this.setState({ loading: true });
      dispatch({
        type: 'articleSubmissions/fetchSynscribenumber',
        params: {
          appCode: getAppCode(),
        },
      })
        .then(res => {
          this.setState({ loading: false, isShow: res });
          message.success('同步成功');
          this.fetchNewsLists(params);
        })
        .catch(() => {
          this.setState({ loading: false });
        });
    }
  };

  renderTimeTooltip = (time, fromApp) => {
    const { currentUser } = this.props;
    const { orgType } = currentUser || {};
    return (
      <Tooltip
        placement="top"
        title={
          <>
            <div>
              发布时间 :{moment(time).format('YYYY-MM-DD HH:mm')}
            </div>
            {
              orgType === 'county' && (
                <div>
                  发布应用 : {formAppData[fromApp]}
                </div>
              )
            }
          </>
        }
      >
        <img src={naozhongIcon} alt='' />
      </Tooltip>
    )
  }

  setColumns = type => {
    const columns = [
      {
        title: '标题',
        dataIndex: 'title',
        key: 'title',
        fixed: 'left',
        width: 330,
        render: (text, record) => {
          const { isTiming = 0, timingPushTime, fromApp } = record.newsInfoExtend || {}
          if (text.length <= 20) {
            return (
              <span className='title-wrap'>
                {
                  isTiming === 1 && this.renderTimeTooltip(timingPushTime, fromApp)
                }
                <span>{text}</span>
              </span>
            )
          }
          return (
            <span className='title-wrap'>
              {
                isTiming === 1 && this.renderTimeTooltip(timingPushTime, fromApp)
              }
              <Tooltip placement="top" title={text}>
                <span>{text.substring(0, 20)}...</span>
              </Tooltip>
            </span>

          );
        },
      },
      {
        title: '发布者',
        dataIndex: 'publishUserName',
        key: 'publishUserName',
        width: 160,
        render: text => {
          if (text) {
            if (text.length <= 8) {
              return <span>{text}</span>;
            }
            return (
              <Tooltip placement="top" title={text}>
                <span>{text.substring(0, 8)}...</span>
              </Tooltip>
            );
          }
          return <span>-</span>;
        },
      },
      {
        title: '相同权限人',
        dataIndex: 'samePermissions',
        key: 'samePermissions',
        width: 120,
        render: samePermissions => {
          if (samePermissions.length) {
            return (
              <Tooltip
                placement="top"
                title={samePermissions.map(item => (
                  <span>{item.userName} </span>
                ))}
              >
                <span>
                  {samePermissions.length > 1
                    ? `${samePermissions[0].userName}...`
                    : samePermissions[0].userName}
                </span>
              </Tooltip>
            );
          }
          return <span>-</span>;
        },
      },
      {
        title: '文章类型',
        dataIndex: 'newstype',
        key: 'newstype',
        render: text => {
          if (text === '0') {
            return <span>图文文章</span>;
          }
          return <span>外链文章</span>;
        },
      },
      {
        title: '最后编辑时间',
        dataIndex: 'gmtModify',
        key: 'gmtModify',
        render: (text, record) => {
          return <span>{moment(text || record.createTime).format('YYYY.MM.DD HH:mm')}</span>;
        },
      },
      {
        title: '处理状态',
        dataIndex: 'status',
        key: 'status',
        render: text => {
          return <Badge color={statusIcon[text]} text={statusText[text]} />;
        },
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 160,
        fixed: 'right',
        render: (text, record) => {
          if (type) {
            return (
              <span>
                {(record.status === 1 ||
                  record.status === 3 ||
                  record.status === 8 ||
                  record.status === 6 ||
                  record.status === 10) && (
                    <>
                      <a
                        onClick={e => {
                          e.stopPropagation();
                          router.push(
                            `/${getPathHeader()}/submissions/submissions/edit?id=${record.id
                            }&appCode=${getAppCode()}&newstype=${record.newstype}`
                          );
                        }}
                      >
                        编辑
                      </a>
                      <Divider type="vertical" />
                      {
                        record.status !== 6 && (
                          <>
                            <a
                              onClick={e => {
                                e.stopPropagation();
                                this.fetchSubmit(record.id);
                              }}
                            >
                              提交
                            </a>
                            <Divider type="vertical" />
                          </>
                        )
                      }
                      <Popconfirm
                        title="确定删除？"
                        placement="top"
                        okText="确定"
                        cancelText="取消"
                        onConfirm={e => {
                          e.stopPropagation();
                          this.confirm(record);
                        }}
                        onClick={e => e.stopPropagation()}
                        onCancel={e => e.stopPropagation()}
                      >
                        <a>删除</a>
                      </Popconfirm>
                    </>
                  )}
              </span>
            );
          }
          return null;
        },
      },
    ];
    this.setState({ columns });
  };

  changePage = (page, pageSize) => {
    const { params } = this.state;
    const tempParams = {
      ...params,
      page,
      pageSize,
    };
    this.setState({ params: tempParams });
    this.fetchNewsLists(tempParams);
  };

  gotoOther = type => {
    this.setState({ nowArticleType: type }, () => {
      const newstype = type === 1 ? 0 : 1;
      router.push(
        `/${getPathHeader()}/submissions/submissions/create?appCode=${getAppCode()}&newstype=${newstype}`
      );
    });
  };

  // 跳转详情
  handleGoToDetail = id => {
    router.push(
      `/${getPathHeader()}/submissions/submissions/approvalDetail?id=${id}&appCode=${getAppCode()}`
    );
  };

  createNews = () => {
    this.setState({ showModal: true });
  };


  handleChangeSelected = (selectedRowKeys) => {
    this.setState({
      selectedRowKeys
    })
    console.log('selectedRowKeys', selectedRowKeys)
  };

  submit = () => {
    const { selectedRowKeys } = this.state;

    const that = this;


    confirm({
      title: '确定提交吗？',
      okText: '确定',
      cancelText: '取消',
      onOk() {
        console.log('OK');
        console.log('submit selectedRowKeys', selectedRowKeys)

        that.fetchSubmit(selectedRowKeys.join(','))


      },
      onCancel() {
        console.log('Cancel');
      },
    });


  }

  render() {
    const {
      columns,
      loading,
      dataSource,
      params,
      totalElements,
      nowArticleType,
      showModal,
      selectedRowKeys
    } = this.state;
    const { page } = params;
    const { form } = this.props;
    const { getFieldDecorator } = form;
    const formItemLayout = {
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
    };

    const pageProps = {
      spinProps: { spinning: loading },
      className: styles.root,
    };


    const tableProps = {
      pageInfo: { totalElements, page },
      columns,
      list: dataSource,
      rowKey: 'id',
      onItemClick: this.handleGoToDetail,
      onPageChange: this.changePage,
      rowSelection: {
        selectedRowKeys,
        onChange: this.handleChangeSelected,
        getCheckboxProps: record => {
          const { status } = record
          if (status === 1 || status === 3 || status === 8 || status === 10) {
            return { disabled: false }
          }
          return { disabled: true }
        }
      },
    };

    return (
      <Container breStates isSplitBar>
        <ListPage {...pageProps}>
          <section className={styles['search-area']}>
            <Row>
              <Col span={8}>
                <Form.Item {...formItemLayout} label="标题">
                  {getFieldDecorator('title', {
                    rules: [
                      {
                        max: 50,
                        message: '请勿超过50个字!',
                      },
                    ],
                  })(<Input placeholder="请输入标题" onPressEnter={this.search} />)}
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item {...formItemLayout} label="状态">
                  {getFieldDecorator(`status`, {
                    initialValue: 0,
                  })(
                    <Select placeholder="请选择">
                      <Option value={0}>全部</Option>
                      <Option value={1}>拟稿中</Option>
                      <Option value={3}>被打回</Option>
                      <Option value={4}>审批中</Option>
                      <Option value={5}>审批成功</Option>
                      <Option value={7}>已发布</Option>
                      <Option value={8}>已撤下</Option>
                      <Option value={10}>已撤回</Option>
                    </Select>
                  )}
                </Form.Item>
              </Col>
              <Col offset={20} style={{ textAlign: 'right' }}>
                <Form.Item>
                  <Button type="primary" onClick={this.search}>
                    查询
                  </Button>
                  <Button onClick={this.reSet}>重置</Button>
                </Form.Item>
              </Col>
            </Row>
          </section>
          <section className="create-button">
            <Button type="primary" onClick={this.createNews}>
              + 新建资讯
            </Button>
            <Tooltip
              placement="top"
              title="可以勾选拟稿中、已撤下的内容进行提交，点击提交时提示“确认提交”确认后提交。"
              overlayStyle={{ width: 300, maxWidth: 300 }}
            >
              <Button style={{ marginLeft: 10 }} onClick={this.submit} disabled={!selectedRowKeys.length}>
                提交
                <Icon type="question-circle" />
              </Button>
            </Tooltip>

            <Tooltip
              placement="top"
              title="手动将已绑定公众号素材管理中的新文章同步至当前列表。同步的文章链接与实际公众号群发的链接不同，若需要文章阅读量进行累加，建议在公众号群发后，通过外链文章类型发布。"
              overlayStyle={{ width: 300, maxWidth: 300 }}
            >
              <Button style={{ marginLeft: 10 }} onClick={this.toMicroToPublic}>
                手动同步
                <Icon type="question-circle" />
              </Button>
            </Tooltip>
          </section>
          <section className="table-area">
            <ListTable {...tableProps} />
          </section>
        </ListPage>
        {showModal && (
          <CreateModal
            showModal={showModal}
            nowArticleType={nowArticleType}
            gotoOther={this.gotoOther}
            onCancel={() => this.setState({ showModal: false })}
          />
        )}
        <Introduction type="pc" appId={66} />
      </Container>
    );
  }
}

const ArticleSubmissionsFrom = Form.create()(ArticleSubmissions);
export default ArticleSubmissionsFrom;
